<template>
  <div class="pagination" v-if="pagination.total > 1">
    <a :class="{'pagination__link--hidden': pagination.currentPage === 1}" class="pagination__link js-pag-p"
       @click="triggerNextPrev($event,pagination.currentPage)" href="javascript:">Previous</a>
    <ul class="pagination__list">
      <li v-bind:class="[pagination.currentPage === item ? 'pagination__list-item js-pagination__list-item pagination__list-item--active' : 'pagination__list-item js-pagination__list-item']"
          v-for="item in activePages" v-bind:key="item">
        <a v-if="isNaN(item)" class="pagination__list-link" href="javascript:">{{ item }}</a>
        <a v-else class="pagination__list-link js-pag-next" href="javascript:"
           @click="triggerPagPage($event, item, pagination.currentPage)">{{ item }}</a>
      </li>
    </ul>
    <a :class="{'pagination__link--hidden': pagination.currentPage === pagination.total}"
       class="pagination__link js-pag-n" @click="triggerNextPrev($event,pagination.currentPage)"
       href="javascript:">Next</a>
  </div>
</template>

<script>

export default {
  beforeMount() {
    this.checkPage();
  },
  props: ['pagination', 'products'],
  computed: {
    activePages: function() {
      const activePages = [];
      for (let i = 0; i < this.sapData.pagination.total; i++) {
        if (Math.abs(i - this.sapData.pagination.currentPage) < 3 || i === this.sapData.pagination.total - 1 || i === 0) {
          activePages.push(i + 1);
        } else if (Math.abs(i - this.sapData.pagination.currentPage) === 4) {
          activePages.push('...');
        }
      }
      return activePages;
    }
  },
  methods: {
    checkPage() {
      const isPage = location.href.indexOf('/page/') > -1;
      if (isPage) {
        this.getIndexPage();
      }
    },
    getIndexPage() {
      let index = '';
      const splitUrl = location.href.split('/');
      for (let i = 0; i < splitUrl.length; i++) {
        if (splitUrl[i] === 'page') {
          index = splitUrl[i + 1];
        }
      }

      this.pagination.currentPage = parseInt(index);
      this.sapData.productsRow = this.sapData.products[parseInt(index) - 1];
    },
    triggerPagPage(event, item, currentPage) {
      if (item === currentPage) {
        return false;
      }
      this.pagination.currentPage = item;
      this.sapData.productsRow = this.sapData.products[item - 1];
      this.paginationUrl(currentPage, item);
    },

    triggerNextPrev(event, page) {
      let paged = this.sapData.pagination.currentPage;
      if (event.target.classList.contains('js-pag-n')) {
        paged = parseInt(page) + 1;
        this.sapData.productsRow = this.sapData.products[page];
      }
      if (event.target.classList.contains('js-pag-p')) {
        paged = parseInt(page) - 1;
        this.sapData.productsRow = this.sapData.products[page - 2];
      }
      this.sapData.pagination.currentPage = paged;
      this.paginationUrl(page, paged);

    },
    paginationUrl(currentPage, newPage) {
      this.scrollToTop();
      let splitUrl = '';
      if (location.search === '') {
        splitUrl = location.href.split('page/');
        window.history.replaceState({}, '', splitUrl[0] + 'page/' + newPage + '/');
      } else {
        if (location.href.indexOf('/page/') > -1) {
          const splitPar = '/page/' + currentPage + '/?';
          splitUrl = location.href.split(splitPar);
          window.history.replaceState({}, '', splitUrl[0] + '/page/' + newPage + '/?' + splitUrl[1]);
        } else {
          splitUrl = location.href.split('?');
          window.history.replaceState({}, '', splitUrl[0] + 'page/' + newPage + '/?' + splitUrl[1]);
        }
      }
    },

    scrollToTop() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }
  },
  data() {
    return {
      // eslint-disable-next-line no-undef
      sapData: sapData,
    };
  },
};
</script>

<style lang="scss" scoped>

.pagination {
  max-width: 410px;
  width: 100%;
  padding-right: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 32px auto;

  @include mq($xl) {
    padding-right: 0;
  }

  @include mq($sm) {
    max-width: 100%;
    flex-wrap: wrap;
    justify-content: center;
  }
}

.pagination__link {
  font-family: $font-second;
  font-size: 14px;
  color: $grey-mid;
  position: relative;
  transition: $dur $ease;

  @include mq($sm) {
    margin: 0 10px;
    order: 2;
  }

  &:hover {
    &::before {
      transition: $dur $ease;
      transform: scale(0);
      opacity: 0;
    }
  }

  &::before {
    content: '';
    background-color: $grey-mid;
    height: 1px;
    width: 100%;
    display: inline-block;
    position: absolute;
    bottom: 0;
    left: 0;
    transition: $dur $ease;
    opacity: 1;
  }

  &--hidden {
    opacity: 0;
    pointer-events: none;
  }
}

.pagination__list {
  display: flex;
  margin: 0 55px;

  @include mq($sm) {
    max-width: 100%;
    width: 100%;
    justify-content: center;
    margin-bottom: 15px;
  }
}

.pagination__list-item {
  margin: 0 4px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: $white;
  transition: $dur $ease;
  border: 1px solid transparent;
  position: relative;

  &:hover {
    border: 1px solid $grey-mid;
    transition: $dur $ease;
  }
}

.pagination__list-link {
  font-family: $font-second;
  font-size: 14px;
  font-weight: 600;
  color: $grey-mid;
  transition: $dur $ease;
  position: relative;
  z-index: 1;
  padding: 2px 7px 2px 6px;
}

.pagination__list-item--active {
  background-color: $grey-mid;
  transition: $dur $ease;

  .pagination__list-link {
    color: $white;
    transition: $dur $ease;
  }
}
</style>
